export default __webpack_public_path__ + "static/media/153.cec2648e.png";